<script setup lang="ts">
import { deleteProfile, getProfileData, getSales } from '@caks/shared/api/user.route'
import { Sale } from '@caks/shared/types/types.api'
import {
  ProfileSalesList,
  ProfilePersonalInfo,
  ProfilePaymentMethods,
  ProfileDeliveryAddresses,
  ProfileOrdersHistory,
} from '~/components/profile'
import { ButtonMain } from '@caks/uikit/button'
import { ModalAside, ModalCentered } from '~/components/modal'
import { IiCart } from '@caks/shared/modules/ii'
import { ModalElement } from '~/types/components.types'
import { useAccountStore } from '@caks/shared/store/store.account'
import { OrderPickup, OrderNewAddress, OrderPromo } from '~/components/order'
import { Component as ComponentType } from 'vue'
import { getUserAddresses } from '@caks/shared/api/user.route'
import { ChipTag } from '@caks/uikit/chip'
import { SkeletonChip } from '@caks/uikit/skeleton'

const router = useRouter()
const store = useAccountStore()
const profile = ref<Sale[]>([])
const asideModal = ref<ModalElement>()
const modal = ref<ModalElement>()
const isProfileAddressCreation = ref(false)
const addresses = ref<any[]>([]) //TODO TYPES

type ModalVisible = 'order' | 'new-address' | 'promo'

const visibleModal = ref<ModalVisible | null>(null)
const isMount = ref(false)

onMounted(async () => {
  const profileData = await getProfileData()
  //@ts-ignore
  profile.value = profileData.data

  const { data } = await getUserAddresses()
  addresses.value = data

  // const { data: sales } = await getSales()

  isMount.value = true
})

const logOut = () => {
  localStorage.removeItem('token')
  router.push('/')
}

const dellUser = async () => {
  const { data } = await deleteProfile()
  localStorage.removeItem('token')
  store.profile = null
  router.push('/')
}

const closeModal = () => {
  visibleModal.value = null
  asideModal.value?.hide()
}

watch(
  () => store.asideModalActive,
  (newVal) => {
    if (newVal) asideModal.value?.show()
  }
)

const openPromoModal = () => {
  visibleModal.value = 'promo'
  modal.value?.show()
}

const openAddressPicker = () => {
  visibleModal.value = 'order'
  modal.value?.show()
}
const openAddressCreate = () => {
  isProfileAddressCreation.value = true
  visibleModal.value = 'new-address'
  modal.value?.show()
}

const makeOrder = () => {
  asideModal.value?.hide()
  router.push('/order')
}

type ModalVisibleContent = {
  [K in ModalVisible]: { component: ComponentType; props: any }
}

const modalVisibleContent = computed((): ModalVisibleContent => {
  return {
    order: {
      component: OrderPickup,
      props: {
        desktop: true,
      },
    },
    'new-address': {
      component: OrderNewAddress,
      props: {},
    },
    promo: {
      component: OrderPromo,
      props: {},
    },
  }
})

const onAddAddress = async () => {
  if (!isProfileAddressCreation.value) {
    visibleModal.value = 'order'
  } else {
    const { data } = await getUserAddresses()
    addresses.value = data

    modal.value?.hide()
  }
}

const onDeleteAddress = (id: number) => {
  addresses.value = addresses.value.filter((el) => el.id !== id)
}
</script>

<template>
  <div class="profile">
    <profile-sales-list />
    <div class="info-wrapper">
      <div class="profile__info">
        <profile-personal-info />
        <profile-delivery-addresses
          :addresses="addresses"
          @add-new-address="openAddressCreate"
          @delete-address="onDeleteAddress"
        />
      </div>
      <profile-orders-history />
    </div>
    <div class="profile__buttons">
      <button-main :button-state="4" style="width: 192px" @click="logOut">Выйти</button-main>
      <button-main :button-state="4" style="width: 192px" @click="dellUser"
        >Удалить аккаунт</button-main
      >
    </div>
    <modal-aside ref="asideModal">
      <ii-cart
        desktop
        @close="closeModal"
        @make-order="makeOrder"
        @open-promo="openPromoModal"
        @open-address="openAddressPicker"
      />
    </modal-aside>
    <modal-centered ref="modal">
      <component
        v-if="visibleModal"
        :is="modalVisibleContent[visibleModal].component"
        v-bind="modalVisibleContent[visibleModal].props"
        @change-visible="(value: ModalVisible) => (visibleModal = value)"
        @close="closeModal"
        @add-address="onAddAddress"
      />
    </modal-centered>
  </div>

  <teleport v-if="isMount" to=".sub-header__chips">
    <li
      v-if="store.categories.length"
      v-for="(food, index) of store.categories"
      :id="`chip-index-${index}`"
      ref="categoriesChipsElements"
      class="category-chip"
    >
      <chip-tag bigger @click="$router.push('/')">
        {{ food.name }}
      </chip-tag>
    </li>
    <div v-else class="chips-skeletons">
      <skeleton-chip v-for="_ in 6" />
    </div>
  </teleport>
</template>

<style scoped lang="scss">
.profile {
  display: flex;
  flex-direction: column;
  gap: 48px;
  max-width: 1328px;
  margin: 0 auto;
  padding: 32px 12px;

  &__info {
    display: flex;
    flex-direction: column;
    gap: 64px;
    width: 50%;
  }

  &__buttons {
    display: flex;
    width: 100%;
    gap: 20px;
    flex-direction: column;
  }
}

.info-wrapper {
  display: flex;
}
</style>
